import {z} from 'zod';
import {AgentRole} from './orchestration.ts';
import {AgentClient} from './common.ts';

export const AgentAssignment=z.strictObject({
 role:AgentRole,client:AgentClient,
 model:z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:/-]{0,119}$/).nullable(),
 effort:z.enum(['low','medium','high']).nullable(),
});
export type AgentAssignment=z.infer<typeof AgentAssignment>;
export const NotebookUrl=z.string().regex(/^https:\/\/(?:notebooklm|notebook)\.google\.com\/notebook\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i);
export const AgentTeamSettings=z.strictObject({
 version:z.literal(1),assignments:z.array(AgentAssignment).length(AgentRole.options.length),
 notebooklm:z.strictObject({enabled:z.boolean(),url:NotebookUrl.nullable()}),
}).refine(t=>new Set(t.assignments.map(a=>a.role)).size===AgentRole.options.length,{message:'Asigna cada especialista exactamente una vez.'})
 .refine(t=>!t.notebooklm.enabled||t.notebooklm.url!==null,{message:'Añade el enlace al cuaderno de NotebookLM.'});
export type AgentTeamSettings=z.infer<typeof AgentTeamSettings>;
